import {
  BASE_URL,
  OBJECTS_DATA,
  ERROR_MSG,
  REF_TABLE,
  REF_TABLE_REF_TABLE_NAME,
  REFERENCE_TABLE_VALUE,
  REFERENCE_TABLE_VALUE_CODE,
  QAFLAGS,
  CODESET,
  REFERENCE_TABLE_NAME,
  REF_TABLE_PAGE,
  QUERY_REFERENCE_TABLE_NAME,
  REF_TABLE_NAME,
  GET_REF_TABLE_NAME,
  REF_TABLE_VALUES,
  API_GATEWAY_KEY,
} from "./Constants";
import Cookies from "js-cookie";

export const fetchObjectData = async () => {
  let response = await fetch(`${BASE_URL}${OBJECTS_DATA}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  if (response.ok) {
    let data = await response.json();
    return data;
  } else {
    return ERROR_MSG;
  }
};

export const fetchCodeSetTable = async (value) => {
  let response = await fetch(
    `${BASE_URL}${REF_TABLE_REF_TABLE_NAME}/${value}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};
export const fetchCodeSetTableWithPagination = async (
  pageNo,
  recordsPerPage,
  value
) => {
  let response = await fetch(
    `${BASE_URL}${REF_TABLE_PAGE}/${pageNo}/${recordsPerPage}${QUERY_REFERENCE_TABLE_NAME}${value}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};

export const getTableId = async (value) => {
  let response = await fetch(
    `${BASE_URL}${REF_TABLE}${REF_TABLE_NAME}/${value}${GET_REF_TABLE_NAME}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};

export const fetchCodeSetListTable = async (value) => {
  let response = await fetch(
    `${BASE_URL}${REF_TABLE_REF_TABLE_NAME}/Code Set`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};

export const addCodeSetTable = async (form) => {
  let response = await fetch(`${BASE_URL}${REF_TABLE}`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(form),
  });
  return response;
};

export const addCodeSetTableValues = async (id, form) => {
  let response = await fetch(
    `${BASE_URL}${REF_TABLE}/${id}${REF_TABLE_VALUES}`,
    {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
      body: JSON.stringify(form),
    }
  );
  return response;
};

export const addNewCodeSetValueinRefTable = async (form) => {
  let response = await fetch(
    `${BASE_URL}${REF_TABLE}${REFERENCE_TABLE_NAME}${CODESET}${REFERENCE_TABLE_VALUE}`,
    {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
      body: JSON.stringify(form),
    }
  );
  return response;
};

export const updateCodeSetTable = async (id, form) => {
  let response = await fetch(`${BASE_URL}${REF_TABLE}/${id}`, {
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(form),
  });
  return response;
};

export const updateCodeSetTableValues = async (id, form) => {
  let response = await fetch(
    `${BASE_URL}${REF_TABLE}/${id}${REF_TABLE_VALUES}`,
    {
      method: "put",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
      body: JSON.stringify(form),
    }
  );
  return response;
};

export const removeCodeSetTable = async (id) => {
  let response = await fetch(`${BASE_URL}${REF_TABLE}/${id}`, {
    method: "delete",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  return response;
};

export const removeTableNamefromCodeSetList = async (tableName) => {
  let response = await fetch(
    `${BASE_URL}${REF_TABLE}${REFERENCE_TABLE_NAME}${CODESET}${REFERENCE_TABLE_VALUE_CODE}/${tableName}`,
    {
      method: "delete",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};

export const fetchQAFLagsListTable = async (value) => {
  let response = await fetch(
    `${BASE_URL}${REF_TABLE_REF_TABLE_NAME}${QAFLAGS}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};

export const addNewQAFlagsinRefTable = async (form) => {
  let response = await fetch(
    `${BASE_URL}${REF_TABLE}${REFERENCE_TABLE_NAME}${QAFLAGS}${REFERENCE_TABLE_VALUE}`,
    {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
      body: JSON.stringify(form),
    }
  );
  return response;
};

export const removeQAFlagsfromRefList = async (qaFlag) => {
  let response = await fetch(
    `${BASE_URL}${REF_TABLE}${REFERENCE_TABLE_NAME}${QAFLAGS}${REFERENCE_TABLE_VALUE_CODE}/${qaFlag}`,
    {
      method: "delete",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};
